import Hls from 'hls.js';

export type VideoSourceController = {
  readonly currentUrl: string | null;
  attach(url: string): void;
  reset(): void;
  destroy(): void;
};

export function createVideoSourceController(video: HTMLVideoElement): VideoSourceController {
  let hls: Hls | null = null;
  let currentUrl: string | null = null;

  const destroyHls = (): void => {
    hls?.destroy();
    hls = null;
  };

  const resetVideo = (): void => {
    video.removeAttribute('src');
    video.load();
  };

  const isHlsUrl = (url: string): boolean => /\.m3u8($|\?)/i.test(url);

  const canUseNativeHls = (): boolean => {
    return video.canPlayType('application/vnd.apple.mpegurl') !== '';
  };

  const shouldUseHlsJs = (url: string): boolean => {
    return isHlsUrl(url) && Hls.isSupported() && !canUseNativeHls();
  };

  return {
    get currentUrl(): string | null {
      return currentUrl;
    },
    attach(url: string): void {
      if (currentUrl === url) return;

      currentUrl = url;

      if (shouldUseHlsJs(url)) {
        destroyHls();
        hls = new Hls();
        hls.loadSource(url);
        hls.attachMedia(video);
        return;
      }

      destroyHls();
      video.src = url;
      video.load();
    },
    reset(): void {
      currentUrl = null;
      destroyHls();
      resetVideo();
    },
    destroy(): void {
      currentUrl = null;
      destroyHls();
      resetVideo();
    },
  };
}
